
import {
    SET_POSITION_ALIGN_SHOW,
    SET_FRAM_SPLIT_ERROR,
    SET_MUTLTIPLE_FIND_REPLACE_SHOW
} from './types';



export const showFindPositionAndAlign = (result) => dispatch => {
    dispatch({
        type: SET_POSITION_ALIGN_SHOW,
        payload: result
    })
};

 

export const showMultipleFindReplace = (result) => dispatch => {
    dispatch({
        type: SET_MUTLTIPLE_FIND_REPLACE_SHOW,
        payload: result
    })
};


export const showFrameSplitError = (result) => dispatch => {
    dispatch({
        type: SET_FRAM_SPLIT_ERROR,
        payload: result
    })
};



// WEBPACK FOOTER //
// ./src/actions/findActions.js